import { LbaItemTag } from "@/components/SearchForTrainingsAndJobs/components/LbaItemTag"

export const TagFormation = () => {
  return (
    <LbaItemTag color="green" iconImageUri="/images/icons/book.svg">
      FORMATION
    </LbaItemTag>
  )
}
